import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  height: min-content;
  padding: 15px;
  margin: 10px 0;
  border-radius: 2px;
  background: ${({ theme }) => theme.color.cardSortBackground};

  :first-child {
    margin-top: 0;
  }

  :last-child {
    margin-bottom: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  height: fit-content;
  justify-content: space-between;
`;

export const Text = styled(TextLayoutComponent)`
  text-align: justify;
  word-break: break-word;
`;

export const ItemsNumber = styled(Text)`
  margin-left: 20px;
`;
